<template>
 <div class="w-100 d-flex align-items-center modal-header-custom">

        <!-- Back / Close -->
        <i style="font-size: 16px !important;"
          class="fas fa-chevron-left back-icon"
          @click="$router.push('/')"
        ></i>

        <!-- Parent Page -->
        <span class="parent-text" @click="$router.push('/')">
          {{ parent }}
        </span>

        <span class="separator">›</span>

        <!-- Current Page -->
        <span class="current-text">
          <i style="font-size: 16px !important;" :class="icon" class="current-icon"></i>
          {{ title }}
        </span>

      </div>
</template>

<script>
export default {
  name: "ModalTitleBar",
  props: {
 

    /* Current page */
    title: { type: String, required: true },
    icon: { type: String, required: true },

    /* Parent page */
    parent: { type: String, required: true },

  }
};
</script>

<style scoped>
.modal-header-custom {
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  font-weight: 600;
}

.back-icon {
  cursor: pointer;
  margin-right: 12px;
  color: #0d6efd;
  font-size: 16px;
}

.back-icon:hover {
  opacity: 0.7;
}

.parent-text {
  color: #0d6efd;
  cursor: pointer;
}

.separator {
  margin: 0 8px;
  color: #6c757d;
}

.current-text {
  display: flex;
  align-items: center;
  color: #212529;
}

.current-icon {
  margin-right: 6px;
  font-size: 14px;
}
</style>
